export const regex = {
  expirationDate: /^(0[1-9]|1[0-2])([0-9]{2})$/,

  // Regex from UK Government (https://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom)
  caPostcode: /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ][\s]?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i,
  gbPostcode:
    /^([Gg][Ii][Rr]\s?0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$/i,
  usPostcode: /^\d{5}$/i,
  usState:
    /^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$/gm,

  cardAmex: /^3[47][0-9]{13}$/,
  cardBCGlobal: /^(6541|6556)[0-9]{12}$/,
  cardCarteBlancheCard: /^389[0-9]{11}$/,
  cardDinersClubCard: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  cardDiscoverCard:
    /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
  cardInstaPaymentCard: /^63[7-9][0-9]{13}$/,
  cardJCBCard: /^(?:2131|1800|35\d{3})\d{11}$/,
  cardKoreanLocalCard: /^9[0-9]{15}$/,
  cardLaserCard: /^(6304|6706|6709|6771)[0-9]{12,15}$/,
  cardMaestroCard: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/,
  cardMastercard: /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
  cardSoloCard: /^(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}$/,
  cardSwitchCard:
    /^(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}$/,
  cardUnionPayCard: /^(62[0-9]{14,17})$/,
  cardVisaCard: /^4[0-9]{12}(?:[0-9]{3})?$/,
  cardVisaMasterCard: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$/,

  fullName: /[a-z].*[a-z]+/i, // At least two letters
  lettersOnly: /^[A-Za-z]+$/,
  numbersOnly: /^[0-9]+$/i,
  nonDigits: /\D/g,
  alphanumeric: /^[A-Z0-9]+$/i,
  containsAnAlphaCharacter: /[A-Z]/i,
}
